import { FOOTER_MJML } from "../common/footer";
import { ONBOARDING_HEADER } from "../common/header";

export const welcome = `
<mjml>
  <mj-head>
    <mj-title>Welcome to Copilotly!</mj-title>
    <mj-preview>We're excited to have you on board</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${ONBOARDING_HEADER(
      "Welcome to Copilotly!",
      "We're excited to have you join us"
    )}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Thank you for signing up! We're excited to have you on board. Your journey with Copilotly begins now, and we're here to help you every step of the way.</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Here are a few things you can do to get started:</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px">
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/100?text=Profile" alt="Complete Profile" width="100px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Complete Your Profile</mj-text>
        <mj-text font-size="14px" align="center">Add your details to personalize your experience.</mj-text>
      </mj-column>
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/100?text=Explore" alt="Explore Features" width="100px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Explore Features</mj-text>
        <mj-text font-size="14px" align="center">Discover what Copilotly has to offer.</mj-text>
      </mj-column>
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/100?text=Connect" alt="Connect with Teams" width="100px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Connect with Teams</mj-text>
        <mj-text font-size="14px" align="center">Invite your team to collaborate.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="20px">
      <mj-column>
        <mj-text font-size="20px" font-weight="bold" align="center">Ready to get started?</mj-text>
        <mj-button background-color="#007bff" color="#ffffff" font-family="Arial, sans-serif" href="#" width="200px" border-radius="4px">Explore Dashboard</mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "welcome",
  name: "Welcome Email",
  category: "onboarding",
  description:
    "A warm welcome email for new users with clear next steps to get started with your platform.",
  features: [
    "Branded header",
    "Personal greeting",
    "Getting started steps",
    "Call-to-action button",
    "Contact information",
  ],
  subject: "Welcome to Copilotly!",
  subTitle: "We're excited to have you on board",
  mjmlTemplate: welcome,
};
